/*
 * @Author: libo 
 * @Date: 2020-11-13 11:24:42 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2022-04-06 19:50:33
 */

<!--过户页面-->
<template>
  <a-spin :spinning="confirmLoading">
    <div>
      <a-collapse v-model="activeKey">
        <a-collapse-panel key="1" header="表具信息">
          <detail-list>
              <detail-list-item term="表编号">{{model.meterId}}</detail-list-item>
              <detail-list-item term="安装经度">{{model.userMeterLng}}</detail-list-item>
              <detail-list-item term="安装维度">{{model.userMeterLat}}</detail-list-item>
              <detail-list-item term="阀门状态">{{model.userValveOpenorclose==0?"无动作":model.userValveOpenorclose==1?"开阀":model.userValveOpenorclose==2?"关阀":''}}</detail-list-item>
              <detail-list-item term="起始读数">{{model.userMeterStartNum}}</detail-list-item>
              <detail-list-item term="计费读数">{{model.userMeterOpenNum}}</detail-list-item>
              <detail-list-item term="表安装地址">{{model.userAddr}}</detail-list-item>
          </detail-list>
        </a-collapse-panel>
        <a-collapse-panel key="2" header="用户信息">
          <div>
            <detail-list title="旧用户信息">
                <detail-list-item term="用户编号">{{model.userId}}</detail-list-item>
                <detail-list-item term="用户姓名">{{model.userName}}</detail-list-item>
                <detail-list-item term="手机号码">{{model.userPhone}}</detail-list-item>
                <detail-list-item term="身份证号">{{model.userIdNumber}}</detail-list-item>
                <detail-list-item term="户型ID">{{model.userHouseholdCode}}</detail-list-item>
                <detail-list-item term="类型编码">{{model.userTypeCode}}</detail-list-item>
                <detail-list-item term="价格编码">{{model.userPriceCode}}</detail-list-item>
                <detail-list-item term="用水状态">{{model.userState}}</detail-list-item>
                <detail-list-item term="区域名称">{{model.userAreaName}}</detail-list-item>
                <detail-list-item term="营收编号">{{model.userPayId}}</detail-list-item>
                <detail-list-item term="类型">{{model.userIdType==1?"自然人":model.userIdType==0?"企业":""}}</detail-list-item>
                <detail-list-item term="优惠信息">{{model.userFreeinfo==1?"按户":model.userFreeinfo==2?"按人":model.userFreeinfo==3?"按月":model.userFreeinfo==4?"按量":""}}</detail-list-item>
                <detail-list-item term="是否允许缴费">{{model.userPayState}}</detail-list-item>
                <detail-list-item term="用水地址">{{model.userMeterAddr}}</detail-list-item>
                <detail-list-item term="小区名或村庄名">{{model.userCommName}}</detail-list-item>
                <detail-list-item term="备注">{{model.remark}}</detail-list-item>
            </detail-list>
          </div>
          <div>
            <a-form :form="form" slot="detail" :colon="false">
              <detail-list title="新用户信息">
                <a-row :gutter="16">
                  <a-col :span="8">
                    <a-form-item label="用户编号">
                      <a-input v-model="model.userId" :readOnly="true" style="background-color:rgb(238,238,238)"></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item label="用户姓名">
                      <a-input v-decorator="['userName',validatorRules.userName]" placeholder="请输入用户姓名"></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item label="手机号码">
                      <a-input v-decorator="['userPhone',validatorRules.userPhone]" placeholder="请输入用户手机号"></a-input>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row :gutter="16">
                  <a-col :span="8">
                    <a-form-item label="身份证号">
                      <a-input v-decorator="['userIdNumber',validatorRules.userIdNumber]" placeholder="请输入身份证号"></a-input>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item label="户型ID">
                      <a-select v-decorator="['userHouseholdCode',validatorRules.userHouseholdCode]" placeholder="请选择用户户型id">
                        <a-select-option v-for="(data,index) in userHouseholdCodeList" :key="data.id" :value="data.id">
                          {{ data.htName }}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item label="类型编码">
                      <a-select v-decorator="['userTypeCode',validatorRules.userTypeCode]" placeholder="请选择用户类型编码">
                        <a-select-option v-for="(data,index) in userTypeList" :key="data.id" :value="data.id">
                          {{data.utName}}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item label="价格编码">
                      <a-select v-decorator="['userPriceCode',validatorRules.userPriceCode]" placeholder="请输入用户价格编码">
                        <a-select-option v-for="(data,index) in userPriceCode" :key="data.id" :value="data.id">
                          {{data.wtName}}
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item label="类型" >
                      <a-select  v-decorator="['userIdType']" placeholder="请选择类型">
                        <a-select-option :value="1">
                          自然人
                        </a-select-option>
                        <a-select-option :value="0">
                          企业
                        </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item label="优惠信息">
                      <a-select v-decorator="['userFreeinfo']" placeholder="请输入用户优惠信息">
                      <a-select-option value="1">
                        按户
                      </a-select-option>
                      <a-select-option value="2">
                        按人
                      </a-select-option>
                      <a-select-option value="3">
                        按月
                      </a-select-option>
                      <a-select-option value="4">
                        按量
                      </a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item label="用水状态" >
                      <j-dict-select-tag v-decorator="['userState',validatorRules.userState]" :triggerChange="true" placeholder="请选择用水状态" dictCode="user_state" style="width:100%"/>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row>
                  <a-form-item label="过户原因" >
                    <a-input v-decorator="['userTransferReason']" placeholder="请输入过户原因"></a-input>
                  </a-form-item>
                </a-row>
                <a-row>
                  <a-form-item label="备注" >
                    <a-textarea v-decorator="['remark']" rows="4" placeholder="请输入备注" style="width:100%"/>
                  </a-form-item>
                </a-row>
              </detail-list>
            </a-form>  
          </div>
        </a-collapse-panel>
      </a-collapse>
    </div>
  </a-spin>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue,listSize } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import { duplicateCheck } from '@/api/api'
  import PageLayout from '@/components/page/PageLayout'
  import DetailList from '@/components/tools/DetailList'
  import AreaWindow from '../../system/modules/areaWindow.vue'
  const DetailListItem = DetailList.Item
  export default {
    name: 'MeterAssignedForm',
    components: {
      JFormContainer,
      PageLayout,
      DetailList,
      DetailListItem
    },
    data () {
      return {
        activeKey:[1,2],
        form: this.$form.createForm(this),
        model: {},
        confirmLoading: false,
        validatorRules: {
          userName:{  //用户姓名
            rules:[
              {required:true, message:'请输入用户姓名！'},
            ]
          },
          userPhone:{  //手机号码
            rules:[
              {required:true,len:11, message:'请输入正确的手机号码！'},
            ]
          },
          userIdNumber:{  //身份证号
            rules:[
              {required:true,len:18, message:'请输入正确的身份证号！'},
            ]
          },
        },
        userHouseholdCodeList:[], // 用户户型
        userTypeList:[], //  类型编码
        userPriceCode:[], // 价格编码
        url: {
          add: "/jeecg-charge/meter/meterUserinfo/add",
          edit: "/jeecg-charge/meter/meterUserinfoTransferRecord/doTransferTask",
          queryById: "/jeecg-charge/meter/meterUserinfo/queryById",
          userHouseholdCodeList: "/jeecg-charge/meter/meterHousehold/list", //用户户型列表接口
          userTypeList:"/jeecg-charge/meter/meterUserType/list",  //类别编码列表接口
          userPriceCode:"/jeecg-charge/meter/meterPriceinfo/list", //价格编码列表接口
        },
      }
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          // this.form.setFieldsValue(pick(this.model,'meterId','userId','userName','userHouseholdCode','userTypeCode','userPhone','userPriceCode','userAddr','userMeterAddr','userMeterLng','userMeterLat','userAddrId','userPayId','userIdNumber','userIdType','userAreaId','userAreaName','userCommName','userState','userMeterStartNum','userMeterOpenNum','userPayState','userFreeinfo','userValveOpenorclose','createTime','createBy','remark'))
        })
        this.queryUserHouseholdCodeList()
        this.queryUserTypeList()
        this.queryUserPriceCode()

      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model,values);
            formData.meterId = this.model.meterId
            formData.id = this.model.id
            formData.userId = this.model.userId
            console.log("过户提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'meterId','userId','userHouseholdCode','userTypeCode','userPhone','userPriceCode','userAddr','userMeterAddr','userMeterLng','userMeterLat','userAddrId','userPayId','userIdNumber','userIdType','userAreaId','userAreaName','userCommName','userState','userMeterStartNum','userMeterOpenNum','userPayState','userFreeinfo','userValveOpenorclose','createTime','createBy','remark'))
      },
      queryUserHouseholdCodeList() {  //用户户型
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.userHouseholdCodeList, params).then((res) => {
          if(res.success){
           this.userHouseholdCodeList = res.result.records;
          //  console.log(this.userHouseholdCodeList);
          }
        })
      },
      queryUserTypeList() {  //类别编码
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.userTypeList, params).then((res) => {
          if(res.success){
           this.userTypeList = res.result.records;
          //  console.log(this.userTypeList);
          }
        })
      },
      queryUserPriceCode() {  //价格编码
        let params = {}
        params.pageNo = 1;
        params.pageSize = listSize;
        getAction(this.url.userPriceCode, params).then((res) => {
          if(res.success){
            this.userPriceCode = res.result.records;
            console.log(this.userPriceCode);
          }
        }) 
      },
      onChange(value) {
      // console.log(value);
      },
      // 查询方案名称是否重复
      validatePlanName(rule, value, callback){
        var params ={
         tableName:'meterinfo',
         fieldName:'meter_id',
         fieldVal:value,
         dataId:this.model.id
        };
        duplicateCheck(params).then((res) => {
          console.log(res);
          if (res.success) {
            callback("请在表具信息页面中添加")
          } else {
            callback()
          }
        })
      },
    }
  }
</script>

<style scoped>
.ant-form-item >>> .ant-form-item-label{
  line-height: 40px;
}
.ant-form-item >>> .ant-select{
  width: 100%;
}
.detail-list >>> .content{
    line-height: normal;
}
</style>
